<i18n>
{
    "en_US": {
        "markdown-preview": "Show full markdown preview",
        "markdown-split": "Show splitted markdown preview",
        "preview": "Preview",
        "split": "Split",
        "title": "Title",
        "edit": "Edit"
    },
    "fr_FR": {
        "markdown-preview": "Voir la prévisualisation Markdown en plein page",
        "markdown-split": "Voir la prévisualisation Markdown en vue scindée",
        "preview": "Prévisualisation",
        "split": "2 colonnes",
        "title": "Titre",
        "edit": "Modifier"
    }
}
</i18n>

<template>
    <div class="markdown-controls">
        <div class="markdown-inherits">
            <button type="button" class="btn btn-link menu-shrink" v-on:click="showMenuMobile">
                <i class="fa fa-bars"></i>
            </button>
            <div class="separator separator-menu-shrink"></div>

            <markdown-controls-toolbar />

            <div class="separator hide-mobile"></div>

            <button type="button" class="btn btn-primary full-preview" v-on:click="toggleMarkdownPreview" v-bind:title="$t('markdown-preview')">
                <i class="fa fa-search"></i>
                {{$t("preview")}}
            </button>
            <button type="button" class="btn btn-primary full-split" v-on:click="toggleMarkdownSplit" v-bind:title="$t('markdown-split')">
                <i class="fa fa-columns"></i>
                {{$t("split")}}
            </button>

            <div class="btn-group">
                <button type="button" class="btn btn-primary dropdown-toggle short-preview-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-columns"></i>
                </button>
                <div class="dropdown-menu blue dropdown-menu-right">
                    <button class="dropdown-item" type="button" v-on:click="toggleMarkdownPreview" v-bind:title="$t('markdown-preview')">
                        <i class="fa fa-search"></i>
                        {{$t("preview")}}
                    </button>
                    <button class="dropdown-item" type="button" v-on:click="toggleMarkdownSplit" v-bind:title="$t('markdown-split')">
                        <i class="fa fa-columns"></i>
                        {{$t("split")}}
                    </button>
                </div>
            </div>
        </div>

        <div class="input-group">
            <input class="form-control bmb-control" v-bind:placeholder="$t('title')" type="text" v-model="selectedNote.title" v-on:input="updateDocumentTitle($event.target.value)" />
            <span class="input-group-btn">
                <dropdown-tags-selector />
                <dropdown-export-selector />
            </span>
        </div>
    </div>
</template>

<script>
    import MarkdownControlsToolbar from "./markdown/controls/Toolbar";
    import DropdownTableSelector from "dropdowns/TableSelector";
    import DropdownTagsSelector from "dropdowns/TagsSelector";
    import DropdownExportSelector from "dropdowns/ExportSelector";
    import { mapState, mapMutations } from "vuex";

    export default {
        name: "Toolbar",
        components: {
            DropdownTableSelector,
            DropdownTagsSelector,
            DropdownExportSelector,
            MarkdownControlsToolbar
        },
        computed: {
            ...mapState("note", ["selectedNote"])
        },
        mounted: function() {
            // Fixing a bug between bootstrap and material design...
            $(".short-preview-split").dropdown();
        },
        methods: {
            updateDocumentTitle: function(value) {
                if (this.selectedNote.id) {
                    document.title = this.$t("edit") + " \"" + value + "\" | " + process.env.VUE_APP_TITLE;
                }
            },
            ...mapMutations("application", ["showMenuMobile", "toggleMarkdownPreview", "toggleMarkdownSplit"])
        }
    }
</script>

<style scoped>
    .markdown-controls {
        height: 56px;
        padding: 12px 18px;
        border-bottom: 1px solid rgb(228, 234, 236);
        transition: all 0.5s ease-in-out 0s;
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
    }

    .markdown-inherits {
        display: inherit;
    }

    .markdown-controls >>> .markdown-controls-toolbar {
        display: -webkit-flex;
        display: flex;
        height: auto;
        padding: 0;
        border-top: 0;
    }

    .menu-shrink, .separator-menu-shrink {
        display: none !important;
    }
    .menu-shrink {
        padding: 6px 12px;
    }
    .btn-group {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        margin: 0 !important;
    }
    .btn-group .dropdown {
        display: inline-block;
    }
    .btn-default, .btn-primary {
        margin-top: 1px;
        margin-bottom: 0;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background-image: none;
        vertical-align: top;
        -webkit-font-smoothing: subpixel-antialiased;
        font-size: 12px;
        transition: border 0.2s linear 0s, color 0.2s linear 0s, width 0.2s linear 0s, background-color 0.2s linear 0s;
        border-radius: 0.1rem;
        text-shadow: 0 -1px 0 rgba(0,0,0,.2);
        display: inline-block;
        padding: 6px 12px;
        font-weight: 100;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        touch-action: manipulation;
        cursor: pointer;
        user-select: none;
    }
    .full-split {
        margin-left: 3px;
    }
    .separator {
        width: 2px;
        height: 30px;
        content: "";
        display: inline-block;
        vertical-align: middle;
        margin: 0px 5px;
        background: rgb(228, 234, 236);
    }
    .btn-link {
        color: rgb(163, 175, 183);
        line-height: 14px;
        margin-bottom: 0;
        margin-top: 1px;
        padding-left: 12px;
        padding-right: 12px;
    }
    .btn-link:hover {
        color: rgb(17, 17, 17);
    }

    .short-preview-split {
        margin-top: 0 !important;
        display: none;
    }
    .dropdown-menu.blue {
        background-color: rgb(36, 124, 240) !important;
    }
    .dropdown-item {
        cursor: pointer;
        font-weight: 100;
        font-size: 14px;
        padding-left: 20px;
        transition: border 0.2s linear 0s, color 0.2s linear 0s, width 0.2s linear 0s, background-color 0.2s linear 0s;
    }
    .dropdown-menu.blue .dropdown-item {
        color: #fff;
    }
    .dropdown-menu.blue .dropdown-item:hover {
        background-color: #0069d9 !important;
    }
    .dropdown-item i {
        padding-right: 5px;
    }

    .input-group {
        flex: 1;
        margin-left: 10px;
    }

    @media screen and (max-width: 1250px) {
        .full-preview, .full-split {
            display: none;
        }
        .short-preview-split {
            display: inline-block;
        }
    }

    @media screen and (max-width: 1100px) {
        .menu-shrink, .separator-menu-shrink {
            display: inline-block !important;
        }
    }

    @media screen and (max-width: 850px) {
        .hide-mobile {
            display: none !important;
        }
        .markdown-controls >>> .markdown-controls-toolbar {
            display: none;
        }
    }

    @media screen and (max-width: 630px) {
        .full-preview {
            display: inline-block !important;
            margin-top: 0 !important;
        }
        .short-preview-split {
            display: none !important;
        }
    }
</style>
